import request from '@/utils/request.js';
// 获取游戏圈信息
export const getCircleInfo = (params) =>
  request({ url: '/v1/game_circle/info', method: 'get', params });
// 获取游戏圈导航列表
export const getCircleNavbarList = (params) =>
  request({ url: '/v1/navigation/game_circle', method: 'get', params });
// 获取最新帖子列表
export const getNewTopicList = (params) =>
  request({
    url: '/v1/conversation/new_list',
    method: 'get',
    params,
  });

// 获取最热帖子列表
export const getHotTopicList = (params) =>
  request({
    url: '/v1/conversation/hot_list',
    method: 'get',
    params,
  });

// 获取精华帖子列表
export const getEssenceTopicList = (params) =>
  request({
    url: '/v1/conversation/essence_list',
    method: 'get',
    params,
  });

// 获取置顶帖子列表
export const getTopTopicList = (params) =>
  request({
    url: '/v1/conversation/top_list',
    method: 'get',
    params,
  });

// 帖子、回复点赞
export const doPraise = (data) => request({ url: '/v1/support/support', method: 'post', data });

// 获取详情页帖子信息
export const getDetailTopicInfo = (params) =>
  request({ url: '/v1/conversation/info', method: 'get', params });

// 获取详情页热门回复
export const getDetailsHotReply = (params) =>
  request({
    url: '/v1/conversation_comment/hot_list',
    method: 'get',
    params,
  });
// 获取多级回复弹窗中楼主回复信息
export const getMultilevelReplyInfo = (params) =>
  request({
    url: '/v1/conversation_comment/parent_info',
    method: 'get',
    params,
  });
// 获取回复列表(一级、二级... 多级)
export const getReplyList = (params) =>
  request({
    url: '/v1/conversation_comment/list',
    method: 'get',
    params,
  });

// 提交回复（一级、二级... 多级）
export const submitReply = (data) =>
  request({
    url: '/v1/conversation_comment/comment',
    method: 'post',
    data,
  });

// 获取发评论的图形验证码
export const captchaComment = (params) =>
  request({
    url: '/v1/captcha/comment',
    method: 'get',
    params,
  });
// 帖子搜索
export const search = (params) =>
  request({
    url: '/v1/conversation/search',
    method: 'get',
    params,
  });
